var exports = {
  "k": "xfb577c5e--e01145--container",
};

module.exports = exports;
